
import about from '~/components/Templates/About/About.vue'
import Provider from '@/services/provider'
import gtm from '~/mixins/gtm.js'

export default {
  name: 'AboutPage',
  mixins: [gtm],
  components: {
    about,
  },
  nuxtI18n: {
    parsePages: true,
    locales: ['pt-br', 'en', 'es', 'es-es', 'es-co', 'es-mx'],
  },

  data() {
    return {
      // GTM
      gtmSubsection: 'About',
      gtmSubsection2: '',
      // SEO
      title: this.$t('seo.about.title'),
      description: this.$t('seo.about.description'),
      url: `${process.env.BASE_URL}${this.$route.path}`,
      locale: this.$i18n.locales.find(l => l.code === this.$i18n.locale).iso,
      routeName: this.$route.name,
      orgSchema: { description: this.$t('seo.about.description'), ...this.$t('seo.organization') },
    }
  },
  head() {
    const basePayload = {
      title: this.title,
      description: this.description,
      url: this.url,
      locale: this.locale,
      routeName: this.routeName,
    }

    return {
      ...Provider.head.useComposeHeadTag({
        ...basePayload,
        schema: [
          { ...Provider.head.setSchemaOrganization({ ...this.orgSchema }) },
          { ...Provider.head.setSchemaWebpage({ ...basePayload }) },
          { ...Provider.head.setSchemaBreadcrumb({ breadcrumbs: this.breadcrumbs }) },
        ],
        meta: {},
        script: [],
        link: [],
      }),
    }
  },

  computed: {
    breadcrumbs() {
      const payload = {
        routePath: this.$route.path,
        dinamicValue: false,
      }

      const list = Provider.breadcrumbs.getItemList(payload)

      return list
    },
  },
}
